import React, { useEffect, useState } from "react";
import Footer from "../component/Footer";
import axios from "axios";
import Modal from "../component/Modal";

export default function Blogs1() {
  const [blog, setBlog] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [type, setType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    if (blog.length === 0) {
      axios
        .get(`${process.env.REACT_APP_SERVER_ROUTE}/blog`)
        .then((res) => {
          setBlog(res.data);
          console.log(blog);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  });
  return (
    <div>
      <div className="bg-white py-24 sm:py-32 ">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <h2 className=" my-5 mx-auto max-w-max rounded-full  bg-slate-100 px-5 py-1 text-center text-2xl font-extrabold  text-purple-500">
              Blog & News
            </h2>
            <p className=" mx-auto max-w-5xl text-center   text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl 2xl:text-9xl">
              <span className="text-purple-500">บทความ</span>และข่าวสาร
            </p>
          </div>

          <div className="grid-cols-2 gap-10 border-t-gray-200 pt-20 sm:grid">
            {blog.sort((a, b) => b.id - a.id).sort((a, b) => b.id - a.id).map((post, idx) => (
              <article
                key={idx}
                className="mb-16  flex cursor-pointer flex-col items-start justify-between duration-200 ease-in-out hover:scale-105"
                onClick={() => {
                  setSelectedItem(post);
                  setType("blog");
                  setOpenDialog(true);
                }}
              >
                <img
                  src={`./img/blog/${post.id}/${post.thumbnail}`}
                  className="mb-5 rounded-2xl w-full"
                />
                <div className="flex items-center gap-x-4 text-xs">
                  <p className="text-gray-500">{post.date}</p>
         
                </div>
                <div className="group relative">
                  <h3 className="mt-3 text-3xl font-semibold leading-tight  text-gray-900 group-hover:text-gray-600">
                    <span className="absolute inset-0" />
                    {post.title}
                  </h3>
                  <p className="line-clamp-3 mt-5  text-xl text-gray-600">
                    {post.description}
                  </p>
                </div>
                <div className="relative mt-8 flex items-center gap-x-4">
                  <img
                    src={`./img/${post.author.imageUrl}`}
                    alt=""
                    className="h-14 w-14 rounded-full bg-gray-50"
                  />
                  <div className="text-lg leading-6">
                    <p className="font-semibold text-gray-900">
                      <a href={post.author.href}>
                        <span className="absolute inset-0" />
                        {post.author.name}
                      </a>
                    </p>
                    <p className="text-gray-600">{post.author.role}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
      <Modal
        isOpen={openDialog}
        selectedItem={selectedItem}
        type={type}
        handleClose={() => {
          setOpenDialog(false);
          setSelectedItem({});
        }}
      />
      <Footer />
    </div>
  );
}
